export class TypeToiture {

    tto_id: string;
    tto_code: string;
    tto_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.tto_id                     = data['tto_id'] ? data['tto_id'] : null;
        this.tto_code                   = data['tto_code'] ? data['tto_code'] : null;
        this.tto_libelle                = data['tto_libelle'] ? data['tto_libelle'] : null;
    }

}
